import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'
import i18n from './locales/i18n'
import VueAxios from 'vue-axios'
import axios from 'axios'
import store from './store'
import moment from 'moment'

import "moment/locale/fr";

moment.locale("fr"); 

const app = createApp(App);

app.config.globalProperties.$moment = moment;

// axios.defaults.headers.common['User-Agent'] = navigator.userAgent;
// axios.defaults.withCredentials = true

// console.log('User-Agent appliqué :', axios.defaults.headers.common['User-Agent']);

app.use(store).use(router).use(i18n).use(VueAxios,axios).mount('#app')
